/**
 * Arabic for the Urgent Inspection — the movement area after bad weather,
 * the runway condition code, and the forms filled from it.
 * Proposed; pending native aviation review. SNOWTAM, NOTAM, FICON and RWYCC
 * are kept as the codes the reports carry.
 */
const ar: Record<string, string> = {
  "0 — nil": "0 — معدوم",
  "1 — poor": "1 — ضعيف",
  "2 — medium to poor": "2 — متوسط إلى ضعيف",
  "3 — medium": "3 — متوسط",
  "4 — good to medium": "4 — جيد إلى متوسط",
  "5 — good": "5 — جيد",
  "6 — dry": "6 — جاف",
  "25% or less coverage: reported as 25%, the third is 6": "تغطية 25% أو أقل: يُبلَّغ عنها 25%، والثلث 6",
  "under 10% coverage: nothing reported, the third is 6": "تغطية أقل من 10%: لا يُبلَّغ عن شيء، والثلث 6",
  "from the runway condition assessment matrix": "من مصفوفة تقييم حالة المدرج",
  "A code may be lowered on observation, never raised.": "يجوز خفض الرمز بناءً على المشاهدة، ولا يجوز رفعه أبداً.",
  "AIS / NOTAM office": "خدمة معلومات الطيران / مكتب النوتام",
  "Air traffic services": "خدمات الحركة الجوية",
  "Airport management / regulator": "إدارة المطار / الجهة التنظيمية",
  "Airport management": "إدارة المطار",
  "Civil aviation authority": "هيئة الطيران المدني",
  "After heavy rain, a thunderstorm, a sandstorm, snow or ice, hail or a strong wind, the movement area is inspected before operations are confirmed safe. Each runway is assessed in thirds for standing water, flooding, snow and ice, surface damage and FOD, and given a runway condition code; each taxiway is checked the same way; each apron for flying debris and equipment moved from where it was secured. Operations are confirmed only when every area has been inspected and no hazard is open.":
    "بعد الأمطار الغزيرة أو العواصف الرعدية أو العواصف الرملية أو الثلوج والجليد أو البَرَد أو الرياح الشديدة، تُفتَّش منطقة الحركة قبل تأكيد سلامة العمليات. يُقيَّم كل مدرج على أثلاث من حيث المياه الراكدة والفيضان والثلج والجليد وتلف السطح والأجسام الغريبة، ويُعطى رمز حالة المدرج؛ ويُفحص كل ممر بالطريقة نفسها؛ وكل ساحة من حيث الحطام المتطاير والمعدات التي تحركت من أماكن تأمينها. لا تُؤكَّد العمليات إلا بعد تفتيش كل منطقة وعدم وجود أي خطر قائم.",
  "Follows ICAO Annex 14 Volume I (condition of the movement area) and the Global Reporting Format in PANS-Aerodromes (Doc 9981): runway thirds counted from the lower-designator threshold, the runway condition code from the assessment matrix, and coverage reported as 25, 50, 75 or 100%. The civil aviation authority makes the inspection mandatory; the aerodrome manual governs who inspects, how fast, and how the report is issued. The codes here are a working aid, not the issued report.":
    "يتبع الملحق 14 المجلد الأول للإيكاو (حالة منطقة الحركة) وصيغة الإبلاغ العالمية في إجراءات خدمات الملاحة الجوية — المطارات (الوثيقة 9981): أثلاث المدرج تُعد من العتبة ذات الرقم الأدنى، ورمز حالة المدرج من مصفوفة التقييم، والتغطية يُبلَّغ عنها 25 أو 50 أو 75 أو 100%. هيئة الطيران المدني تجعل التفتيش إلزامياً؛ ودليل المطار يحدد من يفتش وبأي سرعة وكيف يصدر التقرير. الرموز هنا أداة عمل، لا التقرير الصادر.",
  "Amended from the generated text; the saved copy will say so.":
    "عُدِّل عن النص المُولَّد؛ وستذكر النسخة المحفوظة ذلك.",
  "Back to the generated text": "العودة إلى النص المُولَّد",
  "Check saved and added to the log.": "حُفظ الفحص وأُضيف إلى السجل.",
  "Choose the surface condition.": "اختر حالة السطح.",
  Cleared: "أُزيل",
  "Close with restrictions": "إغلاق مع قيود",
  "Closed with restrictions": "أُغلق مع قيود",
  "Closed with restrictions: {areas}": "أُغلق مع قيود: {areas}",
  "Compacted snow": "ثلج مضغوط",
  "Confirm safe operations": "تأكيد سلامة العمليات",
  "Copied to the clipboard.": "نُسخ إلى الحافظة.",
  "Copies saved from this inspection": "النسخ المحفوظة من هذا التفتيش",
  "Copy the text": "انسخ النص",
  "Coverage of this third, %": "تغطية هذا الثلث، %",
  "Depth, mm": "العمق، مم",
  "Drainage blocked": "انسداد التصريف",
  "Dry or wet snow on top of compacted snow": "ثلج جاف أو رطب فوق ثلج مضغوط",
  "Dry or wet snow on top of ice": "ثلج جاف أو رطب فوق جليد",
  "Dry snow": "ثلج جاف",
  Dry: "جاف",
  "E-mail address (optional)": "البريد الإلكتروني (اختياري)",
  "Each apron": "كل ساحة",
  "Each runway third": "كل ثلث من المدرج",
  "Each taxiway": "كل ممر",
  "Earlier checks of this area in this inspection": "الفحوص السابقة لهذه المنطقة في هذا التفتيش",
  "Equipment moved from its secured place": "معدات تحركت من مكان تأمينها",
  "Every area is inspected and no hazard is open. Operations can be confirmed safe.":
    "فُتِّشت كل المناطق ولا يوجد خطر قائم. يمكن تأكيد سلامة العمليات.",
  "Every area is inspected, but these are not safe: {areas}.": "فُتِّشت كل المناطق، لكن هذه غير آمنة: {areas}.",
  "FAA Part 139": "إدارة الطيران الفيدرالية — الجزء 139",
  FAA: "إدارة الطيران الفيدرالية (FAA)",
  ICAO: "الإيكاو",
  "FICON NOTAM — field condition": "نوتام FICON — حالة المطار",
  "FOD or flying debris": "أجسام غريبة أو حطام متطاير",
  "Fences and screens damaged": "تلف الأسوار والحواجز",
  "First third": "الثلث الأول",
  "Second third": "الثلث الثاني",
  "Last third": "الثلث الأخير",
  "Form text": "نص النموذج",
  Form: "النموذج",
  Forms: "النماذج",
  "Found in the urgent inspection after bad weather.": "وُجد في التفتيش العاجل بعد سوء الأحوال الجوية.",
  Frost: "صقيع",
  "Give the coverage of this third, 0 to 100%.": "أدخل تغطية هذا الثلث، من 0 إلى 100%.",
  "Give the depth in millimetres; it decides the code.": "أدخل العمق بالمليمتر؛ فهو يحدد الرمز.",
  Hail: "بَرَد",
  Hazard: "خطر",
  "Heavy rain or thunderstorm": "أمطار غزيرة أو عاصفة رعدية",
  Ice: "جليد",
  "Inspect {area}": "تفتيش {area}",
  "Inspection in progress": "تفتيش جارٍ",
  "Lights and signs damaged or covered": "أضواء ولوحات تالفة أو مغطاة",
  "Log of this inspection": "سجل هذا التفتيش",
  "Look especially for: {what}.": "ابحث خصوصاً عن: {what}.",
  "Loose sand or drifts": "رمال سائبة أو كثبان",
  "Lower the code on observation (optional)": "خفض الرمز بناءً على المشاهدة (اختياري)",
  "Mark every item clear, hazard or cleared.": "حدد كل بند: سليم أو خطر أو أُزيل.",
  "Markings obscured": "علامات محجوبة",
  "More than 3 mm of water is standing water, not wet.": "أكثر من 3 مم من الماء مياه راكدة، وليس سطحاً مبللاً.",
  "No runway has all three thirds assessed yet, so there is no runway condition to report.":
    "لم تُقيَّم الأثلاث الثلاثة لأي مدرج بعد، فلا توجد حالة مدرج للإبلاغ عنها.",
  "No urgent inspection has been closed yet.": "لم يُغلق أي تفتيش عاجل بعد.",
  "No — keep the matrix code": "لا — أبقِ رمز المصفوفة",
  "Not inspected": "لم يُفتَّش",
  "Not safe — hazard open": "غير آمن — خطر قائم",
  "Note (optional)": "ملاحظة (اختياري)",
  "Nothing has been submitted from this inspection yet.": "لم يُرسل شيء من هذا التفتيش بعد.",
  "Now send it:": "أرسله الآن:",
  "Open in e-mail": "افتح في البريد الإلكتروني",
  "Open the inspection": "افتح التفتيش",
  "Open — conditions reported": "مفتوح — مع الإبلاغ عن الحالة",
  "Operations are not confirmed: {n} area is still to inspect.|Operations are not confirmed: {n} areas are still to inspect.":
    "العمليات غير مؤكدة: لا مناطق متبقية.|العمليات غير مؤكدة: منطقة واحدة لم تُفتَّش بعد.|العمليات غير مؤكدة: منطقتان لم تُفتَّشا بعد.|العمليات غير مؤكدة: {n} مناطق لم تُفتَّش بعد.|العمليات غير مؤكدة: {n} منطقة لم تُفتَّش بعد.|العمليات غير مؤكدة: {n} منطقة لم تُفتَّش بعد.",
  "Other weather event": "حدث جوي آخر",
  "Outside air temperature at or below −15 °C": "درجة حرارة الهواء الخارجي −15 °م أو أقل",
  "Past urgent inspections": "التفتيشات العاجلة السابقة",
  "RWYCC {label}": "رمز حالة المدرج {label}",
  "New Work Order for the hazards": "أمر عمل جديد للأخطار",
  "Remark (optional)": "ملاحظة (اختياري)",
  "Remote apron": "الساحة البعيدة",
  "Apron 1 (contact stands)": "الساحة 1 (مواقف الاتصال)",
  "Apron 2": "الساحة 2",
  "Taxiway A": "الممر A",
  "Taxiway B": "الممر B",
  "Taxiway C": "الممر C",
  "Taxiway D": "الممر D",
  "Taxiway E": "الممر E",
  "Runway condition report, draft:": "تقرير حالة المدرج، مسودة:",
  "SNOWTAM — runway condition report": "سنوتام — تقرير حالة المدرج",
  "Safe operations confirmed": "تأكدت سلامة العمليات",
  "Sandstorm or dust storm": "عاصفة رملية أو ترابية",
  "Save as a file": "احفظ كملف",
  "Save the check": "احفظ الفحص",
  "Save the re-inspection": "احفظ إعادة التفتيش",
  "Saved as {ref}.": "حُفظ بالمرجع {ref}.",
  "Say what stays restricted and why.": "اذكر ما يبقى مقيداً ولماذا.",
  "Say what was observed that lowers the code.": "اذكر ما شوهد مما يخفض الرمز.",
  "Self-inspection record — special inspection": "سجل التفتيش الذاتي — تفتيش خاص",
  "Send to": "أرسل إلى",
  Slush: "ثلج ذائب",
  "Snow, ice or freezing precipitation": "ثلج أو جليد أو هطول متجمد",
  "Snow, slush or ice": "ثلج أو ثلج ذائب أو جليد",
  "Standing water or flooding": "مياه راكدة أو فيضان",
  "Standing water": "مياه راكدة",
  "Stands obstructed": "مواقف معاقة",
  "Start an urgent inspection": "ابدأ تفتيشاً عاجلاً",
  "Start one after any weather that may have changed the movement area. Every runway third, taxiway and apron is then inspected before operations are confirmed safe.":
    "ابدأ تفتيشاً بعد أي حالة جوية قد تكون غيّرت منطقة الحركة. عندها يُفتَّش كل ثلث من المدرج وكل ممر وكل ساحة قبل تأكيد سلامة العمليات.",
  "Strong wind or gusts": "رياح شديدة أو هبات",
  "Submit and save a copy": "أرسل واحفظ نسخة",
  "Submitting keeps an exact copy on the inspection record with a reference and a fingerprint of the text. It does not reach a regulator's system or the NOTAM system by itself: send it by e-mail, as a file, or through the channel the aerodrome manual names.":
    "الإرسال يحفظ نسخة مطابقة في سجل التفتيش مع مرجع وبصمة للنص. لكنه لا يصل بنفسه إلى نظام الجهة التنظيمية أو نظام النوتام: أرسله بالبريد الإلكتروني أو كملف أو عبر القناة التي يحددها دليل المطار.",
  "Surface condition, depth and coverage — the runway condition code": "حالة السطح والعمق والتغطية — رمز حالة المدرج",
  "Surface damage": "تلف السطح",
  "The Global Reporting Format: RWYCC, coverage, depth and condition for each third, then taxiway, apron and sand remarks. For the AIS to issue.":
    "صيغة الإبلاغ العالمية: رمز حالة المدرج والتغطية والعمق والحالة لكل ثلث، ثم ملاحظات الممرات والساحات والرمال. تصدره خدمة معلومات الطيران.",
  "The clipboard is not available here; select the text and copy it.": "الحافظة غير متاحة هنا؛ حدد النص وانسخه.",
  "The same assessment in the FAA field-condition NOTAM format: codes, percent coverage and depth in inches.":
    "التقييم نفسه بصيغة نوتام حالة المطار لدى إدارة الطيران الفيدرالية: الرموز ونسبة التغطية والعمق بالبوصة.",
  "The special inspection after unusual weather: every area, each discrepancy and the action taken, signed.":
    "التفتيش الخاص بعد الأحوال الجوية غير العادية: كل منطقة، وكل مخالفة والإجراء المتخذ، موقَّعاً.",
  "The whole inspection in plain language: trigger, every area's result, hazards, work raised, the outcome and the log.":
    "التفتيش كاملاً بلغة واضحة: السبب، ونتيجة كل منطقة، والأخطار، والأعمال المطلوبة، والنتيجة، والسجل.",
  "There is no inspection to fill a form from yet.": "لا يوجد تفتيش لتعبئة نموذج منه بعد.",
  "This browser would not save the file.": "لم يحفظ هذا المتصفح الملف.",
  "Urgent inspection opened after: {trigger}": "فُتح تفتيش عاجل بعد: {trigger}",
  "Urgent inspection report": "تقرير التفتيش العاجل",
  "Water on top of compacted snow": "ماء فوق ثلج مضغوط",
  "Weather event": "الحدث الجوي",
  "Wet (3 mm or less)": "مبلل (3 مم أو أقل)",
  "Wet ice": "جليد مبلل",
  "Wet snow": "ثلج رطب",
  "What each event leaves behind": "ما يخلّفه كل حدث",
  "What happened (optional)": "ماذا حدث (اختياري)",
  "What is checked, and why": "ما الذي يُفحص، ولماذا",
  "What is left to inspect? What is not safe? What is the runway condition code?":
    "ما الذي بقي للتفتيش؟ ما غير الآمن؟ ما رمز حالة المدرج؟",
  "What stays restricted, and why": "ما يبقى مقيداً، ولماذا",
  "What was observed": "ما شوهد",
  "What, and exactly where": "ماذا، وأين بالضبط",
  "Wildlife on or near the runway": "حياة برية على المدرج أو قربه",
  "Work order {number} raised for {area}": "أُنشئ أمر العمل {number} لـ {area}",
  "Work order {number} raised.": "أُنشئ أمر العمل {number}.",
  "a stand, its clearance lines or the service road blocked": "موقف أو خطوط خلوصه أو طريق الخدمة مسدود",
  "after {trigger} · opened {when} by {who}": "بعد {trigger} · فُتح {when} بواسطة {who}",
  amended: "معدَّل",
  "any foreign object on the surface or blown onto it": "أي جسم غريب على السطح أو حملته الرياح إليه",
  "any frozen contaminant on the surface": "أي ملوث متجمد على السطح",
  "anything that may have changed the movement area": "أي شيء قد يكون غيّر منطقة الحركة",
  "birds or animals drawn to water or insects after the weather":
    "طيور أو حيوانات جذبتها المياه أو الحشرات بعد الحالة الجوية",
  "blast screens, fences, gates or barriers damaged": "تلف حواجز النفث أو الأسوار أو البوابات أو الحواجز",
  "center line, edge, holding position or stand markings not visible":
    "علامات خط المنتصف أو الحافة أو موقع الانتظار أو الموقف غير مرئية",
  "checked {n} times; the last by {who} at {when}. Saving adds a new check and keeps the earlier ones.":
    "فُحص {n} مرات؛ آخرها بواسطة {who} في {when}. الحفظ يضيف فحصاً جديداً ويبقي الفحوص السابقة.",
  "drains, channels or culverts blocked or overflowing": "مصارف أو قنوات أو عبّارات مسدودة أو فائضة",
  "every action, who took it and when; append-only": "كل إجراء، ومن قام به ومتى؛ إضافة فقط",
  "flying debris, equipment, containers and barriers moved from where they were secured, fence and screen damage":
    "حطام متطاير، ومعدات وحاويات وحواجز تحركت من أماكن تأمينها، وتلف الأسوار والحواجز",
  "from threshold {n}": "من العتبة {n}",
  "ground equipment, containers, dollies, steps, cones or barriers shifted, loose or blown over":
    "معدات أرضية أو حاويات أو عربات أو سلالم أو أقماع أو حواجز تحركت أو انفلتت أو انقلبت",
  "ground lights, signs and floodlights broken, out, or covered":
    "أضواء أرضية أو لوحات أو كشافات مكسورة أو مطفأة أو مغطاة",
  "incomplete — not every third has been assessed": "غير مكتمل — لم تُقيَّم كل الأثلاث",
  "loose sand and drifts, markings and lights covered, blown debris, equipment moved on the aprons":
    "رمال سائبة وكثبان، وعلامات وأضواء مغطاة، وحطام متطاير، ومعدات تحركت في الساحات",
  "not inspected yet in this inspection": "لم يُفتَّش بعد في هذا التفتيش",
  "ponding, water over the surface, flooded shoulders or strips":
    "تجمع مياه، أو ماء فوق السطح، أو أكتاف أو شرائط مغمورة",
  "potholes, cracking, spalling, lifted joints or edges, washout":
    "حفر أو تشققات أو تقشر أو فواصل وحواف مرتفعة أو انجراف",
  "sand on the surface or drifted against lights and signs": "رمال على السطح أو متراكمة عند الأضواء واللوحات",
  "snow, slush, ice and frost by depth and coverage, snowbanks, lights and signs covered":
    "ثلج وثلج ذائب وجليد وصقيع حسب العمق والتغطية، وأكوام ثلج، وأضواء ولوحات مغطاة",
  "standing water and ponding, blocked drains, washed-in debris, lightning damage to lights":
    "مياه راكدة وتجمعات، ومصارف مسدودة، وحطام جرفته المياه، وتلف الأضواء بالصواعق",
  "surface and light damage, ice pellets, debris": "تلف السطح والأضواء، وحبيبات جليد، وحطام",
  "{area} inspected again: {verdict}": "أُعيد تفتيش {area}: {verdict}",
  "{area} inspected: {verdict}": "فُتِّش {area}: {verdict}",
  "{form} submitted to {to}, reference {ref}": "أُرسل {form} إلى {to}، المرجع {ref}",
  "{n} min": "{n} دقيقة",
  "{n} thing to complete before saving.|{n} things to complete before saving.":
    "لا شيء للإكمال|أمر واحد للإكمال قبل الحفظ.|أمران للإكمال قبل الحفظ.|{n} أمور للإكمال قبل الحفظ.|{n} أمراً للإكمال قبل الحفظ.|{n} أمر للإكمال قبل الحفظ.",
  "{site} · Aerodrome": "{site} · المطار",
  "{what} — cleared": "{what} — أُزيل",
  "Urgent Inspection": "التفتيش العاجل",
  "The mandatory inspection after bad weather — rain, sandstorm, snow, hail or wind: each runway in thirds with its runway condition code, each taxiway, each apron for flying debris and equipment moved; operations confirmed only when every area is clear; the SNOWTAM, FICON NOTAM, self-inspection record and report filled from it, submitted and kept.":
    "التفتيش الإلزامي بعد سوء الأحوال الجوية — مطر أو عاصفة رملية أو ثلج أو بَرَد أو رياح: كل مدرج على أثلاث مع رمز حالة المدرج، وكل ممر، وكل ساحة من حيث الحطام المتطاير والمعدات المتحركة؛ لا تُؤكَّد العمليات إلا حين تكون كل المناطق سليمة؛ ويُعبَّأ منه السنوتام ونوتام FICON وسجل التفتيش الذاتي والتقرير، ويُرسل ويُحفظ.",
  "in thirds, counted from the threshold with the lower designator, as the runway condition report is":
    "على أثلاث، تُعد من العتبة ذات الرقم الأدنى، كما في تقرير حالة المدرج",
  "each taxiway checked for water, snow and ice, sand, FOD, damage, lights and markings":
    "يُفحص كل ممر من حيث المياه والثلج والجليد والرمال والأجسام الغريبة والتلف والأضواء والعلامات",
  "flying debris, equipment moved from its secured place, stands obstructed, flooding, lights and screens":
    "حطام متطاير، ومعدات تحركت من مكان تأمينها، ومواقف معاقة، وفيضان، وأضواء وحواجز",
  "No urgent inspection is open": "لا يوجد تفتيش عاجل مفتوح",
  "The line for the duty manager": "السطر لمدير المناوبة",
  "written from the inspection record; a connected model may argue and is checked against it":
    "مكتوب من سجل التفتيش؛ قد يناقش نموذج متصل ويُتحقق منه مقابله",
  "each with its trigger, how long it took, and how it closed": "لكل منها سببه ومدته وكيف أُغلق",
  "the items each area is walked for, and what each weather event leaves behind":
    "البنود التي تُفحص في كل منطقة، وما يخلّفه كل حدث جوي",
  "what brought it on; every area of the movement area is then inspected":
    "ما الذي استدعاه؛ ثم تُفتَّش كل مناطق منطقة الحركة",
  "filled from the inspection record": "مُعبأ من سجل التفتيش",
  "filled from the inspection record, for the operator to check, submit and keep; drafts in the published formats, not the issued documents":
    "مُعبأ من سجل التفتيش، ليتحقق منه المشغل ويرسله ويحفظه؛ مسودات بالصيغ المنشورة، لا الوثائق الصادرة",
  "What is left?": "ما الذي بقي؟",
  "What is not safe?": "ما غير الآمن؟",
  "Runway condition": "حالة المدرج",
  "urgent inspection": "التفتيش العاجل",
  "the urgent inspection record": "سجل التفتيش العاجل",
  "areas inspected": "مناطق فُتِّشت",
  "every area has been inspected": "فُتِّشت كل المناطق",
  "{n} still to inspect": "{n} لم تُفتَّش بعد",
  "areas not safe": "مناطق غير آمنة",
  "a hazard is open or a runway third is at RWYCC 1 or 0": "خطر قائم أو ثلث مدرج برمز حالة 1 أو 0",
  "no hazard open": "لا خطر قائم",
  "lowest RWYCC": "أدنى رمز لحالة المدرج",
  "no runway third assessed yet": "لم يُقيَّم أي ثلث من المدرج بعد",
  "minutes since opened": "دقائق منذ الفتح",
  min: "دقيقة",
  "from the start of the inspection": "منذ بدء التفتيش",
  "urgent inspection open": "تفتيش عاجل مفتوح",
  "none open — start one after any weather that may have changed the movement area":
    "لا يوجد تفتيش مفتوح — ابدأ تفتيشاً بعد أي حالة جوية قد تكون غيّرت منطقة الحركة",
  "urgent inspections on record": "تفتيشات عاجلة مسجّلة",
  "last {date}": "آخرها {date}",
  "An urgent inspection is open after {trigger}: {done} of {total} areas inspected.":
    "تفتيش عاجل مفتوح بعد {trigger}: فُتِّشت {done} من {total} منطقة.",
  "Every area is inspected and no hazard is open: operations can be confirmed safe.":
    "فُتِّشت كل المناطق ولا خطر قائم: يمكن تأكيد سلامة العمليات.",
  "{count}: {areas}.": "{count}: {areas}.",
  "No hazard is open so far; operations are not confirmed until every area is inspected.":
    "لا خطر قائم حتى الآن؛ ولا تُؤكَّد العمليات قبل تفتيش كل المناطق.",
  "Runway condition: {line}.": "حالة المدرج: {line}.",
  "No urgent inspection is open.": "لا يوجد تفتيش عاجل مفتوح.",
  "The last was opened {date} after {trigger} and closed with operations confirmed safe.":
    "فُتح آخرها في {date} بعد {trigger} وأُغلق مع تأكيد سلامة العمليات.",
  "The last was opened {date} after {trigger} and closed with restrictions.":
    "فُتح آخرها في {date} بعد {trigger} وأُغلق مع قيود.",
  "None is on record.": "لا يوجد أي تفتيش مسجّل.",
  "{n} area is not safe|{n} areas are not safe":
    "لا مناطق غير آمنة|منطقة واحدة غير آمنة|منطقتان غير آمنتين|{n} مناطق غير آمنة|{n} منطقة غير آمنة|{n} منطقة غير آمنة",
  "No hazard": "لا خطر",
  "No hazard found": "لم يُعثر على خطر",
  "Another urgent inspection is also open — opened {when} by {who}, probably on a phone out of signal. This screen works the earlier one; close the other when its areas are covered here.":
    "يوجد تفتيش عاجل آخر مفتوح أيضاً — فُتح {when} بواسطة {who}، على الأرجح من هاتف خارج التغطية. تعمل هذه الشاشة على الأقدم؛ أغلق الآخر حين تُغطّى مناطقه هنا.",
};
export default ar;
